import React from 'react'
import PropTypes from 'prop-types'
import styled, { withTheme } from 'styled-components'

const Wrapper = styled.div`
  base {
    padding-top: 10%;
    padding-bottom: 90%;
    background-color: var(--clr-accent-to-black);
    color: var(--clr-nav-text);
    width: 100%;
    height: 0;
    text-align: center;
    margin-bottom: 15px;
    h4 {
      font-weight: bold;
      font-size: 1.7em;
      margin-top: 5px;
    }
    p {
      font-size: 0.9em;
      margin-left: 15px;
      margin-right: 15px;
    }
    svg {
      height: 75px;
      width: 75px;
      fill: var(--clr-nav-text);
    }
    @media (max-width: 480px) {
      p {
        display: none;
      }
    }
    @media (min-width: 700px) and (max-width: 991px) {
      padding-bottom: 55%;
    }
    @media (min-width: 1200px) {
      padding-bottom: 75%;
    }
  }
`

const proptypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  active: PropTypes.string
}

let NavTile = ({ title, content, children, active }) => {
  return (
    <div className={active ? 'nav-active' : null}>
      <Wrapper className="nav-tile">
        {children}
        <h4>{title}</h4>
        <p>{content}</p>
      </Wrapper>
    </div>
  )
}

NavTile.propTypes = proptypes

export default withTheme(NavTile)



// WEBPACK FOOTER //
// ./src/components/NavTile/NavTile.js